export enum FeedbackType {
  error = 'error',
  noResults = 'no results',
  success = 'success',
  cat = 'cat',
}
